import { Stack, IconButton, ButtonGroup } from "@chakra-ui/react";
import { observer } from "mobx-react";
import { useStores } from "../../../shared/stores/RootStore";
import {
  AddIcon,
  LayersIcon,
  RemoveIcon,
  TargetIcon,
} from "../../../shared/views/icons";
import { CustomMenu } from "../../../shared/views/CustomMenu";
import { MapboxStylesUrl } from "../../../map/utils/map-utils";

const MapControlsBase = () => {
  const { mapStore } = useStores();

  return (
    <ButtonGroup
      top={2}
      right={2}
      size="xs"
      colorPalette="primary"
      variant="surface"
      position="absolute"
      flexDirection={"column"}
      zIndex={1}
    >
      <Stack gap={0}>
        <IconButton
          title="Zoom in"
          onClick={() => mapStore.zoomIn()}
          borderBottomRadius={0}
        >
          <AddIcon />
        </IconButton>
        <IconButton
          title="Zoom out"
          onClick={() => mapStore.zoomOut()}
          borderTopRadius={0}
        >
          <RemoveIcon />
        </IconButton>
      </Stack>

      <CustomMenu
        items={[
          {
            text: "Standard",
            description: "Colored map",
            key: MapboxStylesUrl.Standard,
            onClick: () => mapStore.setMapStyle(MapboxStylesUrl.Standard),
          },
          {
            text: "Satellite",
            description: "Satellite imagery",
            key: MapboxStylesUrl.Satellite,
            onClick: () => mapStore.setMapStyle(MapboxStylesUrl.Satellite),
          },
        ]}
      >
        <IconButton title="Change layers">
          <LayersIcon />
        </IconButton>
      </CustomMenu>
      <IconButton title="Re-center" onClick={() => mapStore.recenterMap()}>
        <TargetIcon />
      </IconButton>
    </ButtonGroup>
  );
};

export const MapControls = observer(MapControlsBase);
